import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.createContract.types";
import { getNavigationTitle } from "./schema.createContract.utils";
export var getSchema = function (initialValues, _a) {
    var contract = _a.contract, property = _a.property;
    return function (defaultValues) {
        var _a;
        return {
            properties: (_a = {},
                _a[EField.Header + "1"] = {
                    default: undefined,
                },
                _a[EField.OriginalProperty] = {
                    default: getValue(EField.OriginalProperty, initialValues, defaultValues),
                },
                _a[EField.LinkedProperties] = {
                    default: getValue(EField.LinkedProperties, initialValues, defaultValues),
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return _a = {
            "rentio:title": getLocalizedText("contract_info.link_properties.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "1"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("contract_info.link_properties.heading"),
        },
        _a[EField.OriginalProperty] = {
            "ui:field": ERentioFormField.PropertySelectInline,
            title: getLocalizedText("contract.original_property.label"),
            selectPropertyFromListCtaTitle: undefined,
            // @ts-ignore
            hideForm: true,
            valueSelector: function (state, propertyId) {
                var _a;
                if (propertyId) {
                    var property = (_a = state.PROPERTY_V2.detail[propertyId]) === null || _a === void 0 ? void 0 : _a.entity;
                    if (property) {
                        return property.name;
                    }
                    return getLocalizedText("summary.view.property");
                }
                return getLocalizedText("property.no.summary");
            },
        },
        _a[EField.LinkedProperties] = {
            "ui:field": ERentioFormField.PropertySelectInline,
            title: getLocalizedText("contract.link_properties.label"),
            // @ts-ignore
            isMultiSelect: true,
            selectPropertyFromListCtaTitle: undefined,
            valueSelector: function (state, propertyId) {
                var _a;
                if (propertyId) {
                    var property = (_a = state.PROPERTY_V2.detail[propertyId]) === null || _a === void 0 ? void 0 : _a.entity;
                    if (property) {
                        return property.name;
                    }
                    return getLocalizedText("summary.view.property");
                }
                return getLocalizedText("property.no.summary");
            },
        },
        _a;
};
